"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSDKBaseURL = exports.isRudderstackInitialized = exports.isEmpty = exports.isBrowser = void 0;
const constants_1 = require("../constants");
const isBrowser = () => typeof window !== 'undefined';
exports.isBrowser = isBrowser;
const isEmpty = (str) => !str;
exports.isEmpty = isEmpty;
const isRudderstackInitialized = () => {
    if (!(0, exports.isBrowser)() || !window.rudderanalytics) {
        return false;
    }
    return window.rudderanalytics.getAnalyticsInstance().initialized;
};
exports.isRudderstackInitialized = isRudderstackInitialized;
/**
 * A function that determines integration or plugins SDK loading path
 * NOTE: This approach will be removed with next SDK version update because
 * lockVersion will be deprecated
 * https://www.rudderstack.com/docs/sources/event-streams/sdks/rudderstack-javascript-sdk/load-js-sdk/
 */
const getSDKBaseURL = (cdnUrl, assetFolder, lockVersion) => {
    const SDKVersion = lockVersion
        ? constants_1.RUDDERSTACK_SDK_VERSION
        : constants_1.DEFAULT_SDK_VERSION;
    return [cdnUrl, SDKVersion, constants_1.BuildType.Modern, assetFolder].join('/');
};
exports.getSDKBaseURL = getSDKBaseURL;
//# sourceMappingURL=index.js.map